import { INIT_CONTENT } from '../constants/types';

// Define initial state.
const initialState = {
  search: {
    placeholder: '',
    filter: '',
  },
  locationFilter: {
    mobileLabel: '',
    desktopLabel: '',
    buttons: {
      apply: '',
      cancel: '',
      filter: '',
    },
    filters: {
      store: '',
      service: '',
      supercharger: '',
      destinationCharger: '',
    },
  },
  locationDetails: {
    header: {
      store: '',
      gallery: '',
      salesRep: '',
      service: '',
      supercharger: '',
      superchargerOnly: '',
      destinationCharger: '',
    },
    body: {
      directions: '',
      newLocation: {
        label: '',
        title: '',
        info: '',
      },
      buttons: {
        primary: {
          label: '',
          link: '',
        },
        secondary: {
          label: '',
          link: '',
        },
        tertiary: {
          label: '',
          link: '',
        },
      },
    },
  },
  service: {
    notifier: {
      text: '',
      link: '',
    },
    card: {
      header: '',
      image: '',
      button: {
        label: '',
        link: '',
      },
      roadside: {
        text: '',
        phone: '',
      },
    },
  },
  errors: {
    default: '',
    serviceDown: '',
    noLocations: '',
  },
  trips: {
    label: '',
    button: {
      label: '',
      link: '',
    },
  },
};

// Define reducer.
export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_CONTENT:
      return {
        ...state,
        ...action.content,
      };
    default:
      return state;
  }
};
